module.exports = __webpack_public_path__ + "img/dayimg.7e447891.jpg";